export const CAMPAIGN = "CAMPAIGN";
export const TEAM = "TEAM";
export const EMPLOYEE = "EMPLOYEE";
export const ACCOUNT = "ACCOUNT";
export const WALLET = "WALLET";
export const REWARD = "REWARD";
